<template>
  <div class="col-md-3">
    <styled-toggle-refinement label="In scambio" attribute="someone_swaps_it" />
    <styled-toggle-refinement class="mb-2" label="In vendita" attribute="someone_sells_it" />
    <styled-refinement-list
      title="Genere"
      attribute="thema_categories" />
    <styled-refinement-list
      title="Autore"
      attribute="authors.name" />
    <styled-refinement-list
      title="Editore"
      attribute="publisher.name"/>
    <!--
    TODO: Categorie nascoste
    <styled-hierarchical-menu
      title="Genere"
      :attributes="['categories.lvl0', 'categories.lvl1']" />
    -->
    <styled-refinement-list
      title="Lingua"
      attribute="language.title" />
    <styled-refinement-list
      title="Rilegatura"
      attribute="binding" />
    <styled-range-input
      title="Anno di pubblicazione"
      attribute="year"
      class="mb-2"
      :precision="0" />
    <h5 v-b-toggle.score>
      <i class="fas when-closed fa-angle-right"></i>
      <i class="fas when-open fa-angle-down"></i>
      Recensioni
    </h5>
    <b-collapse id="score">
      <ais-rating-menu
        attribute="score"
        :max="5">
        <template v-slot="{ items, refine, createURL, sendEvent }">
          <ul>
            <li v-for="item in items" :key="item.value">
              <a
                :href="createURL(item.value)"
                :style="{ color: item.isRefined ? 'gold' : 'black' }"
                @click.prevent="refine(item.value)"
              >
                <span v-for="(full, index) in item.stars" :key="index">
                  <i
                    :class="{
                      'fas fa-star': full,
                      'far fa-star': !full
                    }"
                  ></i>
                </span>
                e più
                <span class="badge badge-pill badge-primary">{{ item.count }}</span>
              </a>
            </li>
          </ul>
        </template>
      </ais-rating-menu>
    </b-collapse>
  </div>
</template>

<script>
import StyledRefinementList from "./SearchFiltersComponents/StyledRefinementList.vue";
import StyledToggleRefinement from "./SearchFiltersComponents/StyledToggleRefinement.vue";
import StyledRangeInput from "./SearchFiltersComponents/StyledRangeInput.vue";
import StyledHierarchicalMenu from "./SearchFiltersComponents/StyledHierarchicalMenu.vue";

export default {
  name: "BookSearchFiltersSidebar",
  components: {StyledHierarchicalMenu, StyledRangeInput, StyledToggleRefinement, StyledRefinementList},
  data() {
    return {
      currentYear: (new Date()).getFullYear(),
    }
  },
  methods: {
    orderByResultsCount(items) {
      return items.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }

        if (a.count < b.count) {
          return 1;
        }

        return 0
      });
    },
  }
}
</script>

<style scoped>
  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }
</style>
